module.exports = __webpack_public_path__ + "img/cotización.18cf1739.gif";